import { useEffect, useState } from "react";
import { doc, getDoc, collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";

const useMaterials = () => {
  const [materials, setMaterials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMaterials = async () => {
      try {
        setLoading(true);
        setError(null);
        
        // Get the specific document with ID qONG83djlqCPsi8zPTip from the form collection
        const docRef = doc(db, "form", "qONG83djlqCPsi8zPTip");
        const docSnap = await getDoc(docRef);
        
        if (!docSnap.exists()) {
          throw new Error('Materials document not found');
        }
        
        // Get the data subcollection
        const dataRef = collection(db, "form", "qONG83djlqCPsi8zPTip", "data");
        const dataSnap = await getDocs(dataRef);
        
        if (dataSnap.empty) {
          throw new Error('No data found in subcollection');
        }
        
        // Convert all documents to an array of materials
        const materialsArray = dataSnap.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        
        setMaterials(materialsArray);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching materials:", error);
        setError(error.message);
        setMaterials([]);
        setLoading(false);
      }
    };

    fetchMaterials();
  }, []);

  return { materials, loading, error };
};

export default useMaterials;